import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['You are a practicing High School Chemistry teacher', 'You want lessons that are structured, visual and ready to use', 'You want a complete system — not more content to organize', 'You want students genuinely engaged — not just sitting quietly', 'You teach in-person, hybrid, or online', 'You want your classroom to look and feel more professional'];
const notForYou = ['You want a video course or academic certification', 'You expect results without changing anything you do', 'You are not willing to invest in upgrading how you teach', 'You want someone to plan every lesson for you forever'];
export function AudienceSection() {
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-10" data-mp="3cqtsgj6yn6ys">
      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2" data-id="element-11" data-mp="3cqjykkisofnt">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-cobalt/20 bg-[#EEF4FF] p-6 sm:p-8" data-id="element-12" data-mp="3hov8ev93aq61">
          <h3 className="mb-6 text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-13" data-mp="uk7s6ji80xed">
            ✅ This is for you if...
          </h3>
          <ul className="space-y-4" data-id="element-14" data-mp="qiw9yz1ofeg7">
            {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-15" data-mp="llckt43fxh9h">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-16" data-mp="gl83jbupkii7">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-17" data-mp="bn6iildq2943" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-18" data-mp="7llc9ivp0t2v">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="rounded-2xl border border-red-100 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-19" data-mp="25xtrgxhsofdm">
          <h3 className="mb-6 text-lg font-bold text-ink sm:text-xl" data-id="element-20" data-mp="44gukiu2rgxt">
            ❌ This is not for you if...
          </h3>
          <ul className="space-y-4" data-id="element-21" data-mp="3qhxexyqfkdk5">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-22" data-mp="3qful13m5q0a5">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-23" data-mp="i2wy60wn4rbq">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-24" data-mp="mz46u1gf8gxd" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-25" data-mp="941sqr1f7l9h">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}